import React from "react";
import "./About.scss";
import profilePic from "../../assets/images/jensen-chan-photo3.jpg";
import githubIcon from "../../assets/icons/github.svg";
import linkedinIcon from "../../assets/icons/linkedin.svg";
import resumeIcon from "../../assets/icons/cv.svg";

export default function About() {
  return (
    <div className="aboutPage" id="about">
      <h2 className="aboutPage__header"> Something About Myself</h2>
      <div className="aboutPage__container">
        <img
          className="aboutPage__profilePicture"
          src={profilePic}
          alt="Headshot"
        />
        <div className="aboutPage__content">
          <p className="aboutPage__description">
            Hi, my name is Jensen Chan. A pilot turned web developer. Solving
            problems has always been my hobby, and coding has taught and opened
            up new ways to approach problems. I strive toward a career that will
            allow me to work in a constant learning environment and able to
            apply my problem-solving skills through projects.
          </p>
          <div className="aboutPage__contact-container">
            <a href="https://github.com/lyjchan0411">
              <img
                src={githubIcon}
                alt="github"
                className="aboutPage__contact-img"
              />
            </a>
            <a href="https://www.linkedin.com/in/jensen-chan/">
              <img
                src={linkedinIcon}
                alt="linkedin"
                className="aboutPage__contact-img"
              />
            </a>
            <a href="https://drive.google.com/file/d/1kXVJXRj3US6dS_o944lfKoPF0-sop_QY/view?usp=sharing">
              <img
                src={resumeIcon}
                alt="linkedin"
                className="aboutPage__contact-img aboutPage__resume-icon"
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
